var _defs, _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1646.29787 1646.29787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1da1f2;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 823.14894,
    cy: 823.14894,
    r: 823.14894
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1093.1428,1271.68317c372.63283,0,576.41289-308.82512,576.41289-576.62769q0-13.15572-.574-26.195A412.03961,412.03961,0,0,0,1770.03679,563.9158a403.74244,403.74244,0,0,1-116.34023,31.90888,203.38171,203.38171,0,0,0,89.08758-112.09351,406.25166,406.25166,0,0,1-128.643,49.19294,202.31171,202.31171,0,0,0-147.87786-64.03049c-111.87672,0-202.6,90.75936-202.6,202.6341a202.37127,202.37127,0,0,0,5.25627,46.21057c-168.37507-8.47545-317.67786-89.11967-417.59907-211.74376a202.88658,202.88658,0,0,0,62.72194,270.55813,201.04243,201.04243,0,0,1-91.75081-25.34809c-.03011.851-.03011,1.67985-.03011,2.589,0,98.147,69.83065,180.09378,162.52877,198.66233a202.23938,202.23938,0,0,1-91.49394,3.47806c25.79162,80.52379,100.57949,139.12144,189.2496,140.75909a406.32617,406.32617,0,0,1-251.61632,86.74944,411.22912,411.22912,0,0,1-48.32391-2.80773,573.30683,573.30683,0,0,0,310.54707,91.03434",
    transform: "translate(-441.82979 -15.44681)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIc);
export default __webpack_public_path__ + "static/media/twitter-ic.6004bad09a2eff227293d5140f5bba00.svg";
export { ForwardRef as ReactComponent };